module.exports = __webpack_public_path__ + "static/crabrangoon-65fa6689d3bbcdb3f691db545ae10ab6.jpg";